export default __webpack_public_path__ + "static/media/Polish.0a3b0180.mp3";